<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="会员等级">
              <a-input
                placeholder="请输入会员等级"
                v-model="searchObj.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="会员权益">
              <a-input
                placeholder="请输入会员权益"
                v-model="searchObj.benefitsName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="创建人">
              <a-input
                placeholder="请输入创建人"
                v-model="searchObj.createUser"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12" v-if="toggleSearchStatus">
            <a-form-item label="创建时间">
              <a-range-picker
                v-model="searchObj.createTimeRange"
                format="YYYY-MM-DD HH:mm:ss"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],
                }"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
                @ok="onDateOk"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
              >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
              >重置</a-button>
              <!--展开按钮，控制toggleSearchStatus状态-->
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">创建会员等级</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('exportXlsUrl','会员等级记录')">全部导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-dropdown >
          <a-menu slot="overlay">
            <a-menu-item key="2" @click="handleExportXls('exportXlids','会员等级记录')"><a-icon type="download"/>选择导出</a-menu-item>
          </a-menu>
          <a-button> 批量 <a-icon type="down" /></a-button>
        </a-dropdown>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <template slot="statusFlg" slot-scope="val,record">
          <a-switch
            v-model="record.statusFlg"
            checked-children="可见"
            un-checked-children="不可见"
            @click="checked => handleStatusArticle(checked, record)"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => handleDelete(record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <member-level-modal ref="modalForm" :columnChannel="columnChannel" :relationsTree="relationsTree" @ok="modalFormOk"></member-level-modal>
    <member-level-move-modal ref="modalMemberMove" @ok="modalMemberMoveOk"></member-level-move-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import MemberLevelModal from './modules/MemberLevelModal'
  import MemberLevelMoveModal from './modules/MemberLevelMoveModal'
  import { getAction, postAction, downFile } from '@/api/manage';
  import moment from 'moment';
  const columns = [
      {
        title:'排序',
        align:"center",
        dataIndex: 'idx'
      },
      {
        title:'等级名称',
        align:"center",
        dataIndex: 'name'
      },
      {
        title:'会员权益',
        align:"center",
        dataIndex: 'benefitsStr'
      },
      {
        title:'创建人',
        align:"center",
        dataIndex: 'createUser'
      },
      {
        title:'创建时间',
        align:"center",
        dataIndex: 'createTime'
      },
      {
        title:'是否可见',
        align:"center",
        dataIndex: 'statusFlg',
        ellipsis: true,
        scopedSlots: {
          customRender: 'statusFlg'
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        align:"center",
        fixed:"right",
        width:147,
        scopedSlots: { customRender: 'action' }
      }
    ];
  export default {
    name: 'MemberLevelList',
    components: {
      MemberLevelModal,
      MemberLevelMoveModal
    },
    data () {
      return {
        description: '会员等级管理页面',
        columnChannel: [],
        relationsTree: [],
        //--------列表页重复代码 start-------------
        /* 查询折叠 */
        toggleSearchStatus: false,
        searchObj: {
          name: "",
          benefitsName: "",
          createUser:"",
          createTimeRange:[]
        },
        /* table选中keys*/
        selectedRowKeys: [],
        loading: false,
        dataSource: [],
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条';
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        //--------列表页重复代码 end-------------
        // 表头
        columns,
        url: {
          list: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmGroup/list",
          delete: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmGroup/delete',
          statusArticle: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmGroup/updateStatus',
          channelUrl:process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
          equityTree:process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmBenefits/queryTreeList",
          exportXlsUrl: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmGroup/exportXls",
          exportXlids: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmGroup/exportXlsIds",
        },
      }
    },
    created() {
      this.loadData(1);
      this.getChannelData();
      this.loadEquityTree();
    },
    methods: {
      moment,
      handleStatusArticle(checked, record) {
        let status = checked ? 0 : 1;
        record.statusFlg = status;
        postAction(this.url.statusArticle, {
          id: record.id,
          status: checked ? 0 : 1
        }).then(res => {
          if (res.success) {
            this.loadData();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      },
      loadEquityTree(){
        console.log('--loadEquityTree!--');
        getAction(this.url.equityTree).then(res=>{
          if (res.success) {
            let pList = res.result;
            let relationsTree = [];
            for (let i = 0; i < pList.length; i++) {
              let childrenOld = pList[i].ctMmBenefitsVO||[];
              let children = [];
              for (let j = 0; j < childrenOld.length; j++) {
                let c = {
                  key:childrenOld[j].id,
                  value:childrenOld[j].id,
                  title:childrenOld[j].name
                };
                children.push(c);
              }
              let pobj = {
                key:pList[i].benefitType,
                value:pList[i].benefitType,
                title:pList[i].benefitTypeValue,
                children:children
              }
              relationsTree.push(pobj)
            }
            this.relationsTree = relationsTree;
          }else{
            this.$message.error(res.message);
          }
        });
      },
      getChannelData(){
        getAction(
          this.url.channelUrl,
          { channelCode: 'shangzheng_xuetang' }
        ).then(res => {
          if (res.success) {
            this.columnChannel = res.result;
          }else{
            this.$message.error(res.message);
          }
        });
      },
      onDateChange: function(value, dateString) {
        console.log(dateString[0], dateString[1]);
        this.searchObj.startTime = dateString[0];
        this.searchObj.endTime = dateString[1];
      },
      onDateOk(value) {
        console.log(value);
      },
      //-----------------列表页重复代码-开始--------------
      handleToggleSearch() {
        this.toggleSearchStatus = !this.toggleSearchStatus;
      },
      handleExportXls(exportXlsUrlName,fileName) {
        if (!fileName || typeof fileName != 'string') {
          fileName = '导出文件';
        }
        let param = { ...this.searchObj };
        let idParam = ""
        if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          param['ids'] = this.selectedRowKeys.join(',');
          idParam = `?ids=${param.ids}`;
        }
        console.log('导出参数', param);
        downFile(this.url[exportXlsUrlName] + idParam, param).then(data => {
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        });
      },
      //分页
      handleTableChange(pagination, filters, sorter) {
        this.onClearSelected(); //分页切换时清空表格选中
        //分页、排序、筛选变化时触发
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
        }
        this.ipagination = pagination;
        this.loadData();
      },
      loadData(arg) {
        let that = this;
        if (arg === 1) {
          that.ipagination.current = 1;
        }
        let params = this.getQueryParams();
        getAction(this.url.list,params).then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource =
              res.result && res.result.records ? res.result.records : [];
            //额外处理start
            this.dataSource.forEach(item => {
              item.statusFlg = item.status == 0 ? true : false;
            });
            //额外处理end
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      },
      getQueryParams() {
        let param = Object.assign(
          this.searchObj
        );

        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getQueryField() {
        let str = 'id,';
        this.columns.forEach(function(value) {
          str += ',' + value.dataIndex;
        });
        return str;
      },
      handleAdd: function(course) {
        console.log(course);
        if (course) {
          if (course.type == 'click') {
            course = undefined;
          }
        }

        this.$refs.modalForm.add(course);
        this.$refs.modalForm.title = '新增';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleEdit: function(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = '编辑';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleDelete: function(id) {
        if (!this.url.delete) {
          this.$message.error('请设置url.delete属性!');
          return;
        }
        let that = this;
        postAction(that.url.delete, { id: id }).then(res => {
          if (res.success) {
              that.$message.success(res.message);
              that.loadData();
          } else {
            if(res.result.state == 1){
              this.$refs.modalMemberMove.add(id);
            }
            that.$message.warning(res.message);
          }
        });
      },
      modalMemberMoveOk(id) {
        // 新增/修改 成功时，重载列表
        this.handleDelete(id);
      },
      modalFormOk() {
        // 新增/修改 成功时，重载列表
        this.loadData();
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        console.log(this.name);
        if (this.name == 'courseManageModal') {
          let courseList = selectedRowKeys;
          this.form.setFieldsValue({
            courseList
          });
        }
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
      },
      searchQuery() {
        this.loadData(1);
      },
      //重置
      searchReset() {
        this.searchObj = {
          name: "",
          benefitsName: "",
          createUser:"",
          createTimeRange:[]
        };
        this.loadData(1);
      }
      //-----------------列表页重复代码-结束--------------
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>